import axios, { AxiosError } from 'axios';

axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

let csrfToken: string | null = null;

export const refreshCsrfToken = async () => {
  csrfToken = null;

  return axios.get('/csrf-token');
};

axios.interceptors.request.use(
  function (config) {
    const internalConfig = config;

    if (csrfToken) {
      internalConfig.headers['X-CSRF-Token'] = csrfToken;
    }

    return internalConfig;
  },
  function (error: AxiosError) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use((response: any) => {
  const newToken = response.headers['x-csrf-token'];

  if (newToken) csrfToken = newToken;

  return response;
});
